module.exports = __webpack_public_path__ + "static/Truck19-c75350f6c390d12c92f66802759ec337.png";